/**
 * @returns purchase payload for google tag manager
 */
// This purchase event uses a different transaction ID
// from the previous purchase event so Analytics
// doesn't deduplicate the events.
// Learn more: https://support.google.com/analytics/answer/12313109
export function purchase_event_payload(payload) {
  return {
    transaction_id: payload?.sale_id || null,
    affiliation: "oVRcome",
    value: payload.total_price.rawValue,
    shipping: payload?.shipping_price?.rawValue || null,
    items: [
      {
        item_id: payload.plan_id.value,
        item_name: payload.paymentType,
        item_category: payload.programmeCategoryName,
        affiliation: "oVRcome",
        coupon: payload.promoApplied.value,
        currency: payload.currency,
        location_id: payload.address.value,
        price: payload.subscription_cost.rawValue,
        // discount: "100%", // for eg.
        quantity: 1,
      },
    ],
  };
}
